import styled from '@emotion/styled';
import { TextLabel } from 'ds/components/typography';

export const Root = styled.div({
  minHeight: '20px',
});

export const Label = styled(TextLabel)(({ theme }) => ({
  display: 'inline',
  color: theme.colors.neutrals.grey3,
}));

export const LinkLabel = styled(Label.withComponent('a'))``;
